<script>
  // title: string — shown as section heading
  // count: string — shown dimly beside the title
  // headers: string[] — column header labels
  // rows: { path: string, cells: any[] }[] — data rows; path used for export
  // filename: string — base name for the .txt download (without extension)
  export let title = '';
  export let count = '';
  export let headers = [];
  export let rows = [];
  export let filename = 'export';

  function exportTxt() {
    const paths = [...new Set(rows.map(r => r.path))].sort();
    const blob = new Blob([paths.join('\n') + '\n'], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename + '.txt';
    a.click();
    URL.revokeObjectURL(url);
  }
</script>

<section class="diag-section">
  <div class="section-header">
    <h2 class="section-title">
      {title}
      {#if count}<span class="section-count">{count}</span>{/if}
    </h2>
    {#if rows.length > 0}
      <button class="btn-export" on:click={exportTxt}>Export file list (.txt)</button>
    {/if}
  </div>

  <table class="diag-table">
    <thead>
      <tr>
        {#each headers as header}
          <th>{header}</th>
        {/each}
      </tr>
    </thead>
    <tbody>
      <slot />
    </tbody>
  </table>
</section>

<style>
  .diag-section {
    margin-bottom: 2rem;
  }

  .section-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 0.625rem;
  }

  .section-title {
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #475569;
    margin: 0;
    display: flex;
    align-items: baseline;
    gap: 0.625rem;
  }

  .section-count {
    font-size: 0.75rem;
    font-weight: 500;
    color: #94a3b8;
    text-transform: none;
    letter-spacing: 0;
  }

  .btn-export {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 0.3rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    color: #374151;
    background: white;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
    white-space: nowrap;
  }

  .btn-export:hover {
    background: #f8fafc;
    border-color: #93c5fd;
    color: #1d4ed8;
  }

  .diag-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.875rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.75rem;
    overflow: hidden;
  }

  .diag-table :global(th) {
    text-align: left;
    padding: 0.625rem 1.25rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #64748b;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
  }

  .diag-table :global(td) {
    padding: 0.5rem 1.25rem;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: top;
  }

  .diag-table :global(tr:last-child td) {
    border-bottom: none;
  }

  .diag-table :global(tr:hover td) {
    background: #fef9f9;
  }

  .diag-table :global(.source-cell) {
    width: 30%;
    white-space: nowrap;
  }

  .diag-table :global(.event-link) {
    font-family: 'Fira Code', monospace;
    color: #1d4ed8;
    text-decoration: none;
    font-size: 0.825rem;
  }

  .diag-table :global(.event-link:hover) {
    text-decoration: underline;
  }

  .diag-table :global(.pills-cell) {
    display: flex;
    flex-wrap: wrap;
    gap: 0.375rem;
    align-items: flex-start;
    padding-top: 0.375rem;
  }

  .diag-table :global(.broken-id) {
    display: inline-block;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 0.25rem;
    padding: 0.125rem 0.5rem;
    font-family: 'Fira Code', monospace;
    font-size: 0.775rem;
    color: #dc2626;
    font-weight: 500;
  }

  .diag-table :global(.broken-ref) {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 0.25rem;
    padding: 0.125rem 0.375rem;
    font-size: 0.75rem;
  }

  .diag-table :global(.ref-type) {
    color: #9ca3af;
    font-family: 'Fira Code', monospace;
  }
</style>
